import React from 'react';

import { useNavigate } from 'react-router-dom';

import { IActivityFeedCell } from '../../../../types/IActivityFeedCell';

import LoadingCell from '../../../../../ui/table/cells/loadingCell/loadingCell';
import { Tooltip } from '@progress/kendo-react-tooltip';

import './boardNameCell.scss';

const BoardNameCell: React.FC<IActivityFeedCell> = ({ rowType, dataItem, field, width, icon }) => {
  let navigate = useNavigate();

  if (rowType === 'groupHeader') {
    return null;
  }

  if (dataItem[field] === undefined) return <LoadingCell />;

  const navigateToBoard = (investorId: number, boardId: number): void => {
    dataItem.fundId !== null ? navigate(`/boards/${investorId}/${boardId}/${dataItem.fundId}`) : navigate(`/boards/${investorId}/${boardId}`)
  };


  return (
    <td className='document-cell' style={{ width: width }}>
      <Tooltip anchorElement='target'>
        <div className='document-name-wrapper'>
          {icon}
          <span title={dataItem[field]} className='pointer'
                onClick={() => navigateToBoard(dataItem.objectId, dataItem.contentId)}>{dataItem[field]}</span>
        </div>
      </Tooltip>
    </td>
  );
};

export default BoardNameCell;
